import React, { useEffect, useState } from 'react'
import HeaderOne from '../../components/Partials/Headers/HeaderOne'
import Footer from '../../components/Partials/Footers/HomeFour/Footer'
import { gettalukadetails } from '../../Services/service'
import { useParams } from 'react-router-dom'

const TalukasPage = () => {
    const [talukas, setTalukas] = useState([])
    const {id} = useParams();

useEffect(()=>{
loading()
},[id])

async function loading(){
    const tal=await gettalukadetails(id)
    setTalukas(tal.talukadetails[id])
    console.log(tal)
}
  return (
    <div className='talukaspage'>
        <HeaderOne/>
        {/* <div className="news-main-container">
        {talukas ? (
          <div className="newscontainer">
            {/* <h2>{talukas.name}</h2> */}
            {/* <h2>{talukas.place}</h2> */}
            {/* Display Images if Available */}
            {/* {feedData.images && feedData.images.length > 0 && (
              <div>
                {feedData.images.map((img, index) => (
                  <img key={index} src={img} alt={`Image ${index + 1}`} style={{ width: "100%", height:"auto", margin: "5px" }} />
                ))}
              </div>
            )} */}
            {/* <div className="data-opt" style={{display:"flex",gap:"20px",marginTop:"10px"}}>
            <p><strong>Author:</strong> {talukas.author}</p>
            <p><strong>Date:</strong> {talukas.date}</p>
            <p><strong>Views:</strong> {talukas.view}</p>
            <div className="share">
              <ShareButton open={feedData.id}/>
            </div>
            </div> */}
            {/* Display Content */}
            {/* <div className="newsdata">
              {talukas.details && talukas.details.map((item, index) => (
                <div key={index}>
                <img src={item.images} style={{ width:"100%", height:"auto"}} />
                <h2>{item.title}</h2>
                <p >{item.data}
                </p>
                </div>
              ))}
            </div>
          </div> */}
        {/* ) : ( */}
        {/* //   <p>Loading...</p> */}
        {/* )} */}
      {/* </div> } */}
      <div className="talukas-main-container">
        {talukas ? (
            <div className="talukas-table">
  <div className="tabledata">
  {talukas.details && talukas.details.length > 0 && (
    <div className="responsive-table">
      <table>
        <thead>
          <tr>
            {talukas.details[0].title.split('|').map((header, i) => (
              <th key={i}>{header.trim()}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {talukas.details.slice(1).map((item, index) => (
            <tr key={index}>
              {item.data.split('|').map((col, i) => (
                <td key={i}>
                  {i === 3 ? (
                    <a href={`tel:${col.trim()}`} style={{ color: '#007bff', textDecoration: 'none' }}>
                      {col.trim()}
                    </a>
                  ) : (
                    col.trim()
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>



                </div>
        ):(
            <p>Loading...</p>
        )}
      </div>
        <Footer/>
    </div>
  )
}

export default TalukasPage